/**
 * `@loot-os/react/neon-slam`: the Neon Slam opener (a holographic cube on a synthwave grid). It
 * renders with three.js, so it ships on its own entry point with `three`, `@react-three/fiber`,
 * `@react-three/drei`, `@react-three/postprocessing` and `postprocessing` as optional peer
 * dependencies. A host that shows boxes whose opener style is `neon_slam` calls
 * `registerNeonSlam()` once; the scene itself loads on first use.
 */
import { NEON_SLAM_TOKENS } from "./openers/neonSlam/tokens";
import { defineStageOpener, registerOpener } from "./openers/registration";

export const neonSlamOpener = defineStageOpener(
  () => import("./openers/neonSlam/NeonSlamOpener"),
  NEON_SLAM_TOKENS,
);

/** Registers Neon Slam for every opener on the page. Idempotent. */
export function registerNeonSlam(): void {
  registerOpener("neon_slam", neonSlamOpener);
}

export { NEON_SLAM_TOKENS };
